import React from "react";
import { Helmet } from "react-helmet-async";

const PREVIEWS = [
  { title: "1. tüüpi diabeet", slug: "1-tuupi-diabeet" },
  { title: "2. tüüpi diabeet", slug: "2-tuupi-diabeet" },
  { title: "Diabeetiline retinopaatia", slug: "diabeetiline-retinopaatia" },
  { title: "Diabeetiline neuropaatia", slug: "diabeetiline-neuropaatia" },
  { title: "Diabeetiline nefropaatia", slug: "diabeetiline-nefropaatia" },
  { title: "Diabeedi uuringud — A1c, albumiini/kreatiniini suhe ja teised", slug: "diabeedi-uuringud" },
  { title: "Erinevad diabeedi ravimid ja kuidas nad toimivad", slug: "diabeedi-ravimid" },
  { title: "Söömine, liikumine ja kehakaalu langetamine", slug: "soomine-liikumine-kehakaalu-langetamine" },
];

export default function ArticleImagesPreview() {
  return (
    <div className="container-page py-10">
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <h1 className="text-3xl font-semibold text-surface-ink mb-2">
        Artiklite piltide eelvaade
      </h1>
      <p className="text-surface-inkSoft text-[14px] mb-8 max-w-2xl">
        Kõik 8 illustratsiooni genereeritud Gemini Nano Banana mudeliga. Iga pildi all on artikli pealkiri.
        Kui kõik sobivad, ütle "kõik sobivad" ja paneme need artiklite juurde. Kui mõni vajab uuesti
        genereerimist, ütle pildi number/pealkiri ja kirjelda, mida muuta.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {PREVIEWS.map((p, idx) => (
          <div key={p.slug} className="card-clinic" data-testid={`preview-${p.slug}`}>
            <div className="text-[11px] font-semibold uppercase tracking-wider text-teal-500 mb-2">
              {String(idx + 1).padStart(2, "0")}
            </div>
            <h2 className="text-[16px] font-semibold text-surface-ink mb-3 leading-snug">
              {p.title}
            </h2>
            <div className="aspect-video w-full overflow-hidden rounded-xl bg-surface-canvas border border-surface-outline/40">
              <img
                src={`/api/static/ai-images/articles/${p.slug}.png`}
                alt={p.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="mt-3 text-[12px] text-surface-inkSoft break-all">
              /api/static/ai-images/articles/{p.slug}.png
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
